import { render, staticRenderFns } from "./standard-email-input.vue?vue&type=template&id=50230aa9&"
import script from "./standard-email-input.vue?vue&type=script&lang=ts&"
export * from "./standard-email-input.vue?vue&type=script&lang=ts&"
import style0 from "./standard-email-input.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports